import { render, staticRenderFns } from "./smartWarning.vue?vue&type=template&id=12686614&scoped=true&"
import script from "./smartWarning.vue?vue&type=script&lang=js&"
export * from "./smartWarning.vue?vue&type=script&lang=js&"
import style0 from "./smartWarning.vue?vue&type=style&index=0&id=12686614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12686614",
  null
  
)

export default component.exports